<template>
  <div class="ph-goods-grid">
    <div class="grid_item item-line" :class="index==list.length-1?'mb30':''" v-for="(item, index) in list" :key="index">
      <div  @click="toInfo(item.id)">
        <div class="image-box">
          <img :src="item.goods_images + '?imageView2/1/w/480/h/480'"  v-lazy="item.goods_images+ '?imageView2/1/w/480/h/480'">
        </div>
        <div class="item-box">
          <div class="name">
            <div class="ns">{{item.brand_english}}</div>
            <div class="cs" v-if="item.chengse != null && item.chengse != ''">[{{item.chengse}}]</div>
          </div>
          <div class="content">
            <div class="price sale-price" v-if="item.shelevs_type != 3">
              <span class="cred fw" v-if="item.goods_price>0"><em>￥</em>{{item.goods_price}}</span>
              <span class="market-price" v-if="item.original_price>0">￥{{item.original_price}}</span>
            </div>
            <!-- TODO:判断条件展示商品标签 -->
            <div class="flag-box">
              <div class="transfer-icon-flag zhuanxiang" v-if="item.s_discount == 2">
                <span class="icon"><van-icon name="fire" size="14px"/><em>活动</em></span>
                <span>专享</span>
              </div>
              <div class="transfer-icon-flag temai" v-if="item.s_discount == 1">
                <span class="icon"><van-icon name="clock" size="14px"/>限时</span>
                <span>特卖</span>
              </div>
              <div class="transfer-flag ziying" v-if="item.is_self == 1">胖虎自营</div>
              <div class="transfer-flag youxuan" v-if="item.is_self == 0">优选商家</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div style="position: absolute; right: 0.15rem; bottom: 0.15rem;">
        <i class="iconfont icon-share" @click="goodInfo(index,item.goods_name)"></i>
      </div> -->
       <div class="good-mask" v-if="item.shelevs_type == 3" @click="toInfo(item.id)">
        <img src="@/assets/sp.png" alt="">
        <div class="mask-flag"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'goodgrid',
  props: {
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  computed: {
    userLevel: function () {
      return this.$store.getters.userLevel || ''
    }
  },
  methods: {
    toInfo (id) {
      this.$router.push({ name: 'shopGoodsDetail', params: { gid: id } })
    }
  }
}
</script>

<style lang="less" scoped>
.ph-goods-grid {
  // background: #ffffff;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  .grid_item:nth-child(odd) {
    margin-right: 16px;
  }
  .grid_item {
    width: 343px;
    height: 492px;
    background: #fff;
    margin-bottom: 16px;
    border: 1px solid #F7F7F7;
    background-clip: padding-box;
    box-sizing: border-box;
    position: relative;
    img {
      width: 343px;
      height: 330px;
      margin: 0 auto;
    }
    .item-box {
      padding: 20px 10px 20px;
      box-sizing: border-box;
      flex:1;
      min-width:0;
    }
    .name {
      color: #333333;
      font-size: 26px;
      position: relative;
      .ns {
        width: 200px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
        line-height: 1.3;
      }
      .cs {
        font-size:26px;
        position: absolute;
        right: 0;
        bottom: 3px;
        text-align: right;
        line-height: 24px;
      }
    }

    .content {
      .price {
        font-size:24px;
        color: #333;
        font-weight:400;
        text-align: left;
      }
      .flag-box{
        display: flex;
      }
      .sale-price{
        margin: 10px 0;
      }
      .market-price{
        color: #999;
        text-decoration: line-through;
        margin-left: 10px;
      }
      i {
        display:inline-block;
        font-size: 36px;
      }
    }
  }
  .good-mask{
    width: 343px;
    height: 492px;
    position: absolute;
    top: 0;
    // background: #fff;
    // opacity: .8;
    // .mask-flag{
    //   height: 100px;
    //   background: url('../../assets/logo.png') no-repeat;
    //   background-size: 330px;
    //   background-position: center;
    // }
    img{
      width:180px;
      height: 180px;
      display: block;
      position: relative;
      top: 15%;
    }
  }
}
.cred{
  color: #DA3232;
  font-size: 32px;
  em{
    font-size: 24px;
    font-style: normal
  }
}
.transfer-flag{
  // width:100px;
  height:30px;
  text-align: center;
  font-size:20px;
  font-weight:400;
  padding: 2px 4px;
  line-height:30px;
  border-radius:2px;
  margin-right: 10px;
}
// 优选商家
.youxuan {
  background:rgba(40,40,40,1);
  color: rgba(255, 209, 51, 1);
}
// 胖虎自营
.ziying {
  background: #FF9015;
  color: rgba(40,40,40,1);
}
.transfer-icon-flag{
  height: 30px;
  line-height: 30px;
  display: flex;
  align-items: center;
  border-radius: 2px;
  font-size: 20px;
  border: 1px solid rgba(218, 50, 50, 1);
  background:rgba(218,50,50,1);
  margin-right: 10px;
  position: absolute;
  left: 130px;
  &>span:last-child{
    height: 30px;
    background: #fff;
    box-sizing: border-box;
    color: rgba(218, 50, 50, 1);
    padding: 0 4px;
  }
  .icon{
    display: flex;
    box-sizing: border-box;
    height: 30px;
    align-items: center;
    color: #fff;
    padding: 2px 4px;
    em{
      font-style: normal;
      font-size: 20px;
      line-height: 20px;
    }
    i{
      margin-right: 2px;
    }
  }
}

// // 限时特卖
// .temai {
//   .icon{
//     color: #fff;
//   }
// }
// // 活动专享
// .zhuanxiang {
//   .icon{
//     color: #fff;
//   }
// }
</style>
